











import Vue from 'vue';
import type { PropOptions } from 'vue';
import IconNotificationRed from '~/components/Icon/NotificationRed.vue';
import IconNotification from '~/components/Icon/Notification.vue';

export default Vue.extend({
  name: 'HeaderMenuNotificationsToggler',
  components: { IconNotificationRed, IconNotification },
  props: {
    hasUnseen: {
      type: Boolean,
      default: false,
    } as PropOptions<boolean>,
  },
});
